import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useOverlayPortal } from "../../lib/overlayPortal";

/* 长按（手机）→ open({x, y})；500ms 内移动 / 松开则取消 */
export function useLongPress(open, ms = 500) {
  const t = useRef(null);
  const cancel = () => { if (t.current) { clearTimeout(t.current); t.current = null; } };
  const onTouchStart = (e) => {
    const p = e.touches?.[0];
    if (!p) return;
    const x = p.clientX, y = p.clientY;
    cancel();
    t.current = setTimeout(() => { t.current = null; open({ x, y }); }, ms);
  };
  return { onTouchStart, onTouchEnd: cancel, onTouchMove: cancel, onTouchCancel: cancel };
}

/* 消息右键 / 长按菜单（微信式图标网格）：挂到 body，层级高于悬浮沟通窗；点外部 / Esc / 滚动关闭 */
export const MessageMenu = ({ pos, items, mid, onClose }) => {
  const portal = useOverlayPortal(); // 长按菜单不能落回业务弹窗下方。
  const ref = useRef(null);
  const [p, setP] = useState(pos);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    setP({ x: Math.max(8, Math.min(pos.x, window.innerWidth - r.width - 8)), y: Math.max(8, Math.min(pos.y, window.innerHeight - r.height - 8)) });
  }, [pos]);
  useEffect(() => {
    const down = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    const key = (e) => { if (e.key === "Escape") onClose(); };
    const close = () => onClose();
    document.addEventListener("mousedown", down, true);
    document.addEventListener("touchstart", down, true);
    document.addEventListener("keydown", key);
    window.addEventListener("scroll", close, true);
    window.addEventListener("resize", close);
    return () => { document.removeEventListener("mousedown", down, true); document.removeEventListener("touchstart", down, true); document.removeEventListener("keydown", key); window.removeEventListener("scroll", close, true); window.removeEventListener("resize", close); };
  }, [onClose]);
  const vis = items.filter((it) => it && !it.hidden);
  return createPortal(
    <div ref={ref} role="menu" data-testid={`chat-msg-menu-${mid}`} style={{ left: p.x, top: p.y }} onContextMenu={(e) => e.preventDefault()}
      className="fixed z-[10002] w-[272px] max-w-[calc(100vw-16px)] rounded-2xl border border-slate-200 bg-white/95 backdrop-blur shadow-2xl p-2 grid grid-cols-4 gap-1 animate-in fade-in zoom-in-95 duration-100">
      {vis.map((it) => {
        const Icon = it.icon;
        return (
          <button type="button" key={it.key} role="menuitem" data-testid={`chat-menu-${it.key}-${mid}`} data-on={it.on ? 1 : 0} disabled={it.disabled}
            onClick={() => { onClose(); it.onClick(); }}
            className={`flex flex-col items-center gap-1 rounded-xl px-1 py-2 text-[10px] leading-tight transition-colors disabled:opacity-40 ${it.danger ? "text-rose-600 hover:bg-rose-50" : it.on ? "text-[#4F6BFF] bg-indigo-50/70 hover:bg-indigo-50" : "text-slate-700 hover:bg-slate-100"}`}>
            <Icon className="h-4 w-4" />
            <span className="truncate w-full text-center">{it.label}</span>
          </button>
        );
      })}
    </div>, portal || document.body);
};
